export enum Breakpoint {
  XS = 420,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
}
